export default __webpack_public_path__ + "static/media/Exams-rafiki.d96fa836.svg";